import axios from "axios";
import i18n from "i18next";
import { useContext, useState } from "react";
import { ToastContext } from "./../../component/global/ToastContext";
import { isAxiosTransportError } from "./axiosTransportError";

export function useRequest(url, method, token, loaderInitState, headers) {
    const show = useContext(ToastContext);
    const CancelToken = axios.CancelToken;
    const [loading, setLoading] = useState(loaderInitState || false);
    const [cancel, setCancel] = useState();
    const response = async (data, params, tail) => {
        setLoading(true);
        let finalUrl = url;
        if (tail) {
            finalUrl += tail + "/";
        }
        if (params) {
            for (let param of params) {
                finalUrl = finalUrl.replace(":" + param.name, param.value);
            }
        }

        return axios({
            method,
            url: finalUrl,
            data,
            params: method.toLowerCase() === "get" ? data : undefined,
            cancelToken: new CancelToken(function executor(c) {
                setCancel(() => c);
            }),
            headers: {
                Authorization:
                    sessionStorage.getItem("auth") || token
                        ? `Bearer ` + (sessionStorage.getItem("auth") || token)
                        : undefined,
                "Accept-Language": i18n.language || "fa",
                ...headers,
            },
        })
            .then((r) => {
                setLoading(false);

                return r.data;
            })
            .catch((e) => {
                console.log(axios.isCancel(e));
                if (isAxiosTransportError(e) && typeof show === "function") {
                    show(i18n.t("PleaseInternet.label"), "danger");
                }
                if (axios.isCancel(e)) {
                    throw new Error("Request Cancelled");
                } else {
                    setLoading(false);

                    if (
                        e.response?.status === 401 &&
                        sessionStorage.getItem("auth")
                    ) {
                        sessionStorage.removeItem("auth");
                        window.location.reload();
                    } else {
                        throw e;
                    }
                }
            });
    };

    return [response, loading, cancel];
}
